import { useState, useEffect } from "react";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css"; // BootstrapのCSSをインポート
import Button from "react-bootstrap/Button"; // React BootstrapのButtonコンポーネントをインポート
import GetKanjiSentence from "./component/GetKanjiSentence";
import { sampleQ } from "./Questions";
import AnswerWindow from "./component/AnswerWindow";
import { FetchQuestionModal } from "./component/FetchQuestionModal";
import AppNavbar from "./component/Navbar";

export default function App() {
  //let questions = sampleQ
  const [questions, setQuestions] = useState(sampleQ);
  const [nowQuestion, setNowQuestion] = useState(1);
  const fullSentence: string =
    questions.find((object) => object.id === nowQuestion)?.fullSentence || "";
  const answer: string =
    questions.find((object) => object.id === nowQuestion)?.answer || "";
  const [time, setTime] = useState(0);
  const [isRunning, setIsRunning] = useState(false);
  const [isDisplayAnswer, setIsDisplayAnswer] = useState(false);

  useEffect(() => {
    if (isRunning) {
      const id = setInterval(() => {
        setTime(time + 10);
      }, 10);
      return () => clearInterval(id);
    }
  }, [isRunning, time]);

  //const [datas, setDatas] = useState([])

  /*
  const sheetID = "1vW8GsMAmVXl1zJRJ3zXO97MzOqykDzxBgQY0QfdwzUc"
	useEffect(() => {
		 fetch(`https://sheets.googleapis.com/v4/spreadsheets/${sheetID}/values/sheet1?key=${process.env.REACT_APP_GOOGLE_SHEETS_API_KEY}`)
			.then(res => res.json())
			.then(datas =>
				setDatas(datas.values))
	}, [])
	console.log(datas);
  */
  //const [sheetID, setSheetID] = useState("");

  return (
    <div>
      <AppNavbar/>
      <div className="App-header">
        
        <FetchQuestionModal setQuestions={setQuestions} setTime={setTime}/>
        <h1>Q{nowQuestion}</h1>
        <GetKanjiSentence fullSentence={fullSentence} time={time} />
        <AnswerWindow sentence={isDisplayAnswer ? answer : ""} />
        <div>
          <Button
            variant="primary"
            className="my-button"
            size="lg"
            onClick={() => {
              setIsRunning(!isRunning);
            }}
          >
            {isRunning ? "Pause" : "Play"}
          </Button>
          <Button
            variant="danger"
            className="my-button"
            size="lg"
            onClick={() => {
              setIsDisplayAnswer(!isDisplayAnswer);
            }}
            disabled={Boolean(
              answer === "",
            )}
          >
            Answer
          </Button>
          <Button
            variant="secondary"
            className="my-button"
            size="lg"
            onClick={() => {
              setIsRunning(false);
              setTime(0);
            }}
          >
            Reset
          </Button>
          <Button
            variant="secondary"
            className="my-button"
            size="lg"
            onClick={() => {
              setNowQuestion(nowQuestion - 1);
              setIsRunning(false);
              setTime(0);
              setIsDisplayAnswer(false);
            }}
            disabled={Boolean(
              !questions.find((object) => object.id === nowQuestion - 1),
            )}
          >
            Prev
          </Button>
          <Button
            variant="secondary"
            className="my-button"
            size="lg"
            onClick={() => {
              setNowQuestion(nowQuestion + 1);
              setIsRunning(false);
              setTime(0);
              setIsDisplayAnswer(false);
            }}
            disabled={Boolean(
              !questions.find((object) => object.id === nowQuestion + 1),
            )}
          >
            Next
          </Button>
        </div>
      </div>
    </div>
  );
}
